import React, { useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CrewSelection from "../Filters/CrewSelection";
import PlanTypeSelection from "../Filters/PlanTypeSelection";
import SearchBox from "../Filters/SearchBox";
import ActionButton from "./ActionButton";
import Recently from "../Filters/Recently";
import EGFilter from "../Filters/EGFilter";
import { setCrewFilteredList } from "../../../actions/crew-kanban";
import { getRateScheduleLists } from "../../../actions/rate-schedule";

const BoardHeader = () => {
    const dispatch = useDispatch();
    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);

    useMemo(() => {
        dispatch(getRateScheduleLists(farmId))
    }, [farmId])

    return <Row className="kanban-header crewManagement_header mx-0">
        <Col lg={4} md={4} sm={4} className="pl-0">
            <div className="kanban-title crewManagement_title mr-3">
                <h4 className="mr-2 my-0">Manage Crews</h4>
                <div className="d-flex">
                    <CrewSelection />
                    <Recently />
                </div>
            </div>
        </Col>
        {/* <Col lg={4} md={4} sm={4}>
            <div className="d-flex">
                <CrewSelection />
                <Recently />
            </div>
        </Col>
         */}
        <Col lg={4} md={4} sm={4}>
            <div className="crewHeadSearch_filter">
                <SearchBox />
                <EGFilter className='crewCommon_filter' onFilter={egIds => dispatch(setCrewFilteredList(egIds))} />
            </div>
        </Col>
        <Col lg={4} md={4} sm={4} className="pr-0">
            <div className="d-flex float-right crewActions_btn">
                <ActionButton />
                <div className="splitter" />
                <PlanTypeSelection />
            </div>
        </Col>
    </Row>;
};

export default BoardHeader;
